<template>
  <div>
    <div v-if="alertKind === 'success'">
      <Alert
        v-model="alertKind"
        :icon="['far', 'info-circle']"
        :timeout="seconds + 1"
      >
        {{ isBeingEdited ? 'This global link has been updated succesfully.' : 'A new global link has been added.' }} <span v-html="closeMessage" />
      </Alert>
    </div>
    <div v-else>
      <div v-if="alertKind === 'danger'">
        <Alert
          v-model="alertKind"
          :icon="['far', 'info-circle']"
        >
          An error has occurred while processing your request. Please contact <a href="mailto:producthelp@cendyn.com">producthelp@cendyn.com</a> for assistance.
        </Alert>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-row">
            <div
              :class="['form-group', 'col-md-12', 'required', {error: 'description' in errors}]"
            >
              <ejs-textbox
                v-model="form.description"
                float-label-type="Always"
                placeholder="Description"
                :css-class="errors.description.length ? 'e-error' : ''"
                :blur="(args) => onFieldBlur('description', args)"
              />
              <div
                v-if="errors.description.length"
                class="error"
              >
                {{ errors.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12">
          <div class="form-row">
            <div
              :class="['form-group', 'col-md-12', 'required', {error: 'link' in errors}]"
            >
              <ejs-textbox
                v-model="form.link"
                float-label-type="Always"
                placeholder="Link"
                :css-class="errors.link.length ? 'e-error' : ''"
                :blur="(args) => onFieldBlur('link', args)"
              />
              <div
                v-if="errors.link.length"
                class="error"
              >
                {{ errors.link }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <button
          class="btn btn-lg btn-outline-secondary dialogBtnCancel"
          tabindex="-1"
          @click="cancel"
        >
          Cancel
        </button>
        <button
          class="btn btn-lg btn-danger dialogBtnSubmit"
          tabindex="-1"
          @click="save"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Alert from '@/components/Alert'

export default {
  components: {
    Alert
  },
  props: {
    seconds: {
      type: Number,
      required: false,
      default: 5
    }
  },
  data () {
    return {
      isBeingEdited: false,
      alertKind: '',
      alertSeconds: this.seconds,
      form: {
        id: 0,
        companyId: parseInt(this.$route.query.externalId),
        description: '',
        link: ''
      },
      errors: {
        description: '',
        link: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      globalLinkOnEdition: 'getGlobalLinkOnEdition'
    }),
    hasErrors () {
      let nErrors = 0
      Object.keys(this.errors).forEach(key => {
        if (this.errors[key].length) nErrors++
      })
      return nErrors > 0
    },
    closeMessage () {
      return `This dialog will automatically close in <strong>${this.alertSeconds}</strong> seconds.`
    }
  },
  watch: {
    globalLinkOnEdition (newVal) {
      if (newVal !== null) {
        this.isBeingEdited = true
        this.form.id = newVal.id
        this.form.companyId = newVal.companyId
        this.form.description = newVal.description
        this.form.link = newVal.link
      } else {
        this.form.id = 0
        this.form.companyId = parseInt(this.$route.query.externalId)
        this.form.description = ''
        this.form.link = ''
      }
    }
  },
  methods: {
    ...mapActions([
      'getGlobalLinks',
      'addGlobalLink',
      'updateGlobalLink'
    ]),
    onFieldBlur (field, args) {
      this.validateField(field)
    },
    validateField (field = '') {
      // const { name, linkTagging, tags, description } = this.form
      if (!(field in this.form) || typeof this.form[field] === 'undefined') return

      switch (field) {
        case 'description': {
          const { description } = this.form
          this.errors[field] = this.$validation.isEmpty(description, 'The Description field is required') || this.$validation.minLength(description, 3, 'The description should have at least [MIN] characters') || this.$validation.maxLength(description, 255, 'The description should have at most [MAX] characters')
        }
          break
        case 'link': {
          const { link } = this.form
          this.errors[field] = this.$validation.isEmpty(link, 'The link field is required') || this.$validation.isURL(link) || this.$validation.maxLength(link, 1000, 'The link should have at most [MAX] characters')
        }
          break
      }
    },
    validateForm () {
      this.validateField('description')
      this.validateField('link')
    },
    cancel () {
      if (this.$parent.$parent.$parent.$refs.globalLinkAddModal) {
        this.$parent.$parent.$parent.$refs.globalLinkAddModal.closeDialog()
      } else {
        this.$parent.$parent.$parent.$refs.globalLinkEditModal.closeDialog()
      }
    },
    clearForm () {
      this.form.description = ''
      this.form.link = ''
      this.errors.description = ''
      this.errors.link = ''
    },
    save () {
      this.validateForm()
      if (!this.hasErrors) {
        const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
        if (this.form.id) {
          this.updateGlobalLink({ linkId: this.form.id, userEmail, data: this.form })
            .then(response => {
              this.getGlobalLinks({ userEmail })
              this.alertKind = 'success'
              this.startCountdown()
              this.clearForm()
              this.$store.commit('SET_GLOBAL_LINK_ON_EDITION', null)
              setTimeout(() => {
                this.cancel()
              }, this.seconds * 1000)
            })
            .catch(err => {
              console.log(err)
              this.alertKind = 'danger'
            })
        } else {
          this.addGlobalLink({ userEmail, data: this.form })
            .then(response => {
              this.getGlobalLinks({ userEmail })
              this.alertKind = 'success'
              this.startCountdown()
              this.clearForm()
              this.$store.commit('SET_GLOBAL_LINK_ON_EDITION', null)
              setTimeout(() => {
                this.cancel()
              }, this.seconds * 1000)
            })
            .catch(err => {
              console.log(err)
              this.alertKind = 'danger'
            })
        }
      }
    },
    startCountdown () {
      this.alertInterval = setInterval(() => {
        if (this.alertSeconds > 0) {
          this.alertSeconds--
        } else {
          clearInterval(this.alertInterval)
          this.alertSeconds = this.seconds
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap4.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap4.css';

  .template-creator {
    position: relative;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: none;
    background-color: #ffffffcf;
    &.active {
      display: block;
    }
  }

  .divider {
    border-bottom: 1px solid $gray-light;
  }

  .e-float-input input, .e-float-input.e-control-wrapper input, .e-float-input textarea, .e-float-input.e-control-wrapper textarea {
    border-radius: 2px;
  }
  .e-btn-primary {
    border-radius: 2px;
    color: $white;
    background-color: $bocalipstick;
    border-color: $bocalipstick-dark;
  }
</style>
